import React from 'react';
import PropTypes from 'prop-types';
import { FilterProperty } from '../FilterBoxes';

const SelectedPropertiesFilter = ({
  filteredPropertyIds,
  handleFilterProperties,
  properties,
}) => {
  const mappedProperties = properties.map((property) => ({
    id: property.propertyId,
    name: property.propertyName,
  }));
  return (
    <FilterProperty
      initialSelectedProperties={filteredPropertyIds}
      properties={mappedProperties}
      onPropertySelect={handleFilterProperties}
    />
  );
};

SelectedPropertiesFilter.propTypes = {
  filteredPropertyIds: PropTypes.arrayOf(PropTypes.number),
  handleFilterProperties: PropTypes.func.isRequired,
  properties: PropTypes.arrayOf(
    PropTypes.shape({
      aiEmailEnabled: PropTypes.string,
      emailProductEnabled: PropTypes.string,
      genAiEmailEnabled: PropTypes.string,
      leasingEnabled: PropTypes.bool,
      propertyId: PropTypes.number.isRequired,
      propertyName: PropTypes.string.isRequired,
      residentEnabled: PropTypes.bool,
      tableData: PropTypes.shape({
        id: PropTypes.number,
      }),
    }),
  ),
};

export default SelectedPropertiesFilter;
